export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}

export function isTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(hover: none) and (pointer: coarse)').matches ||
    navigator.maxTouchPoints > 0
  );
}

/** Téléphone ou tablette tactile (Android/iPad) — pas le desktop classique. */
export function isTabletOrMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;
  if (isMobileViewport()) return true;
  if (isTouchDevice() && window.matchMedia('(max-width: 1280px)').matches) {
    return true;
  }
  return false;
}

export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

/** Navigateur mobile/tablette : l’app doit être installée (PWA). */
export function mustUsePwaOnMobile(): boolean {
  return isTabletOrMobileDevice() && !isStandalonePwa();
}

export function pushNotificationsSupported(): boolean {
  if (typeof window === 'undefined') return false;
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}
